interface User {
  aud?: string
  confirmed?: boolean
  email?: string
  email_confirmation_required?: boolean
  exp?: number
  firstName?: string
  iat?: number
  iss?: string
  jti?: string
  lastName?: string
  login_timestamp?: string
  ls?: string
  passwordType?: string
  r?: boolean
  sub?: string
  uid?: string
  valid?: boolean
}
import I18n from "@helper/i18nInstance"
import { useErrorPopup } from "./ErrorPopup"
import { useCallback, useRef } from "react"

export type PianoUser = User;

export interface LoggedInObject {
  token?: string
  user?: User
}
declare global {
  // eslint-disable-next-line no-var
  var tp: {
    pianoId?: {
      show: (options: {
        loggedIn: (data: LoggedInObject) => void
      }) => void
    }
  } | undefined
}

const usePianoId = (success: (userToken: string) => void) => {
  const { showError } = useErrorPopup()
  const showErrorRef = useRef(showError)
  showErrorRef.current = showError
  const successRef = useRef(success)
  successRef.current = success

  return useCallback(() => {
    if (typeof tp !== "undefined" && tp?.pianoId) {
      try {
        tp.pianoId.show({
          loggedIn: ({ token }) => {
            if (token) {
              successRef.current(token)
            } else {
              showErrorRef.current({
                title: I18n.t("quiz.quiz_eval.login.error_title"),
                content: I18n.t("quiz.quiz_eval.login.error"),
              })
            }
          }
        })
      } catch (e) {
        showErrorRef.current({
          title: I18n.t("quiz.quiz_eval.login.error_title"),
          content: I18n.t("quiz.quiz_eval.login.error"),
        })
      }
    } else {
      showErrorRef.current({
        title: I18n.t("quiz.quiz_eval.login.error_title"),
        content: I18n.t("quiz.quiz_eval.login.error"),
      })
    }
  }, [])
}

export default usePianoId